import type { FaireProductEntity } from "../../entity_types/product";

export const p_xncymrjgs6: FaireProductEntity = {
  token: "p_xncymrjgs6",
  type: "product",
  name: "Soul Eater, Vol. 25",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/9d6b335ed60817ad40551b32e8928898a3c6f5e4aa35a6747612104f874d80a6.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "Kid's sense of order stands in sharp contrast to the unpredictable madness of the Kishin. But order and madness are two sides of the same coin. When Asura challenges the 'tyrannical' Shinigami and his laws that serve to control humans' lives, Kid can feel the tendrils of madness within himself seeking purchase. The bonds of his friendships and his faith in order are tested to their limits as Asura makes his final stand against the forces of DWMA. When the moondust settles, who will emerge as lord of this world--Shinigami or Kishin?",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:36.719Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
